module.exports = __webpack_public_path__ + "static/media/icon-especialidade.c4fb8899.svg";